export default __webpack_public_path__ + "static/media/manageStudent.3a95f28a.png";